import { render, staticRenderFns } from "./canjiren_jynldwjycjrzkdcb.vue?vue&type=template&id=5fd31a7e&scoped=true"
import script from "./canjiren_jynldwjycjrzkdcb.vue?vue&type=script&lang=js"
export * from "./canjiren_jynldwjycjrzkdcb.vue?vue&type=script&lang=js"
import style0 from "./canjiren_jynldwjycjrzkdcb.vue?vue&type=style&index=0&id=5fd31a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd31a7e",
  null
  
)

export default component.exports